<ng-container *ngIf="currentMerchant$ | async as merchant">
  <div class="row">
    <h3>
      {{ "reports.customer-report.title" | translate }}
    </h3>
  </div>
  <div class="row disclaimer">
    <div class="caption">
      <small>
        {{ "reports.customer-report.disclaimer" | translate }}
      </small>
    </div>
  </div>
  <form [formGroup]="reportForm" (ngSubmit)="submitReportForm()">

    <div class="row input">
      <div class="datepicker">
        <app-datepicker
          formControlName="fromDate"
          [placeholder]="'reports.customer-report.form.fromDate' | translate"
          [maxDate]="reportForm.get('toDate').value"
        >
        </app-datepicker>
        <span>
          <i class="fa fa-minus fa-sm" aria-hidden="true"></i>
        </span>
        <app-datepicker
          formControlName="toDate"
          [placeholder]="'reports.customer-report.form.toDate' | translate"
          [minDate]="reportForm.get('fromDate').value"
          [useEndOfDay]="true"
        >
        </app-datepicker>
      </div>
    </div>

    <div class="row input">
      <div class="content">
        <select type="text" formControlName="posId" class="input">
          <option
            [value]="''"
            [selected]="!reportForm.get('posId').value || reportForm.get('posId').value == ''"
          >
            {{ "reports.customer-report.form.posId" | translate }}
          </option>
          <option
            *ngFor="let p of merchant.pointOfSales"
            [value]="p.id"
            [selected]="reportForm.get('posId') && reportForm.get('posId').value === p.id"
          >
            {{ p.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="row input">
      <div class="content">
        <input
          type="text"
          class="input"
          [placeholder]="'reports.customer-report.form.pos-identifier' | translate"
          formControlName="posName"
        />
      </div>
    </div>
    <div class="row input">
      <div class="content">
        <input
          type="text"
          class="input"
          [placeholder]="'reports.customer-report.form.paycardId' | translate"
          formControlName="cardId"
        />
      </div>
    </div>
    <div class="row input">
      <div class="content">
        <input
          type="text"
          class="input"
          [placeholder]="'reports.customer-report.form.deviceId' | translate"
          formControlName="deviceId"
        />
      </div>
    </div>
  </form>
  <hr>
  <ng-container *ngIf="customerSalesReport$ | async as report">
    <div class="row report-results">
        <span>
          {{ 'reports.records-found' | translate: { count: report.count } }}
        </span>
        <span>
           <button class="btn" type="button" [disabled]="!report || report.count === 0" (click)="downloadCSV()">
          {{ 'reports.controls.download' | translate }}
        </button>
        </span>
    </div>
  </ng-container>
</ng-container>
